window.Vue = require("vue");
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate"
import * as Cookies from 'js-cookie'

Vue.use(Vuex);

import state from "./state";
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);

export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	plugins: [createPersistedState({
		paths: [
			'standardsSearchTerm'
		],
		storage: {
			getItem: key => Cookies.get(key),
			// Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
			setItem: (key, value) =>
				Cookies.set(key, value, {
					expires: inFiveMinutes
				}),
			removeItem: key => Cookies.remove(key),
		},
	})]
});